<template>

  <footer class="module module--footer">
    <BgBox v-if="bgbox" :opacity="getHeroOpacity" :src="getHeroImage" :invert="getHeroInvert" :alt="_translate('local.footer.image.alt')">
      <div class="grid grid--footer grid--gap">
        <div class="grid__item">
        	<div class="footer-content">
          	<slot name="details"></slot>
        	</div>
        </div>
        <!-- <div v-if="!isTablet && doLocal && !isLocal" class="grid__item">
        	<div class="footer-cta">
          	<slot name="cta"></slot>
          </div>
        </div> -->
      </div>
    </BgBox>
    <div v-else class="module__body">
    	<div class="container">
    		<div class="wrapper">
		      <div class="grid grid--footer grid--gap">
		        <div class="grid__item">
		        	<div class="footer-content">
		          	<slot name="details"></slot>
		        	</div>
		        </div>
		        <!-- <div v-if="!isTablet && doLocal && !isLocal" class="grid__item">
		        	<div class="footer-cta">
		          	<slot name="cta"></slot>
		          </div>
		        </div> -->
		      </div>
		    </div>
		  </div>
    </div>
    <!-- <div v-if="isTablet && doLocal" class="footer-cta">
       <slot name="cta"></slot>
    </div> -->

    <div class="module__body">
      <div class="container">
        <div class="wrapper wrapper--legal">

          <div class="footer-item">
            <div class="footer-item__logo"><img class="site-footer__logo site-footer__logo--mls" src="/img/realtor-logo.svg" alt="MLS Logo"></div>
            <p class="footer-item__text" v-html="_translate('local.footer.realtor')"></p>
          </div>

          <div class="footer-item">
            <div class="footer-item__logo"><img class="site-footer__logo site-footer__logo--mls" src="/img/mls-logo.png" alt="MLS Logo"></div>
            <p class="footer-item__text" v-html="_translate('local.footer.mls')"></p>
          </div>

          <p class="footer-sources" v-html="_translate('local.footer.sources')"></p>
        </div>
      </div>
    </div>

  </footer>

</template>

<script>

  import BgBox from '@/components/BgBox.vue'
  import Button from '@/components/Button.vue'
  import SocialShare from '@/components/SocialShare.vue'

	export default {

		components: {
			BgBox,
			Button,
			SocialShare
		},

	  props: {

	  	bgbox : {
	  		type: Boolean,
	  		default: false,
	  	},

        local: {
            type: Boolean,
            default: false,
        }

	  },

    computed: {

      isLocal: function() {
        return this.local;
      },

      getHeroImage: function() {

        return (this.local) ? 'header-2020-local' : 'footer';

      },

      getHeroInvert: function() {

        if ( this.doLocal ) {
          return this.isReport ? false : true;
        } else {
          return false;
        }

      },

      getHeroOpacity: function() {

        if ( this.doLocal ) {
          return this.isReport ? Number(.2) : Number(.1)
        } else {
          return .2;
        }

      },

    }

	}

</script>

<style lang="scss">

	.module--footer {

    .wrapper--legal {
      max-width: 47rem;
      padding: 1.5rem;

      @include mq('tab') {
        padding: 0;
      }

      p {
        font-size: 11px;
        line-height: 20px;
        color: $grey;
      }

    }

    .bg-box {

      &.white {

        .footer-cta {
          color: $black;
          background-color: $white;
        }
      }

      .wrapper {

        margin-top: 0;
        padding-bottom: 6rem;

      }

    }

  }

  $footer-logo-width: 60px;
  .footer-item {
    display: flex;
    margin-bottom: 1rem;
    align-items: center;

    p {
      width: calc(100% - #{$footer-logo-width});
    }

  }

  .footer-item__logo {

    width: $footer-logo-width;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-right: 1.25rem;

    img {
      max-width: 100%;
      height: auto;
      display: block;
      flex: 1;
    }

  }

  .footer-item__text {

    margin: 0;

  }

  .footer-sources {

    margin-top: 2rem;
    padding: 1.5rem .5rem 0;
    border-top: 2px solid $mist-dark;

    text-align: center;

  }

  .footer-content {

    padding: 6rem 0 2rem;
    position: relative;

    .share {

      position: absolute;
      left: 0;
      top: 100%;
      padding-top: 3rem;

      .email {

        margin-left: 0;

        @include mq('tab') {
          margin-left: 1rem;
        }

      }

    }

    .share__label {
      text-align: left;
    }

  }

  .footer-cta {

    background: $black;
    height: 100%;
    text-align: center;
    color: $white;
    padding: 3rem 1rem;
    box-shadow: $box-shadow;

    @include mq('lap') {
      padding: 6rem 2rem 1px;
      text-align: left;
    }

    p {

      margin-top: 0;
      margin-bottom: 2rem;

      @include mq('lap') {
        margin-top: 5.125rem;
        margin-bottom: 2.5rem;
      }

    }

  }

</style>